
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 4.573 1.239"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.212 0a.203.203 0 00-.148.064A.17.17 0 000 .2v.847a.17.17 0 00.064.137.224.224 0 00.148.053h2.053a.225.225 0 00.148-.053.17.17 0 00.064-.137V.201a.17.17 0 00-.064-.137A.204.204 0 002.265 0z"}}),_c('path',{attrs:{"d":"M2.308.001a.203.203 0 00-.148.064.17.17 0 00-.064.137v.847a.17.17 0 00.064.138.224.224 0 00.148.052H4.36a.225.225 0 00.148-.052.17.17 0 00.064-.138V.202a.17.17 0 00-.064-.137A.204.204 0 004.361 0z"}})])
          )
        }
      }
    